import jQuery from 'jquery'
import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";

const customAnmation = new CustomAnimation();
let layerOpen = false;
// teilnehmer 2 validation check
let participant2List = [];
participant2List.push('#firstname_participant_2');
participant2List.push('#lastname_participant_2');
participant2List.push('#street_participant_2');
participant2List.push('#street_number_participant_2');
participant2List.push('#postcode_participant_2');
participant2List.push('#city_participant_2');
participant2List.push('#birth_participant_2');
participant2List.push('#gender_participant_2');
participant2List.push('#size_participant_2');

function showLayer() {
  layerOpen = true;
  updateLayer();
  jQuery('.tournament_check').addClass("show");
  jQuery('body').addClass("overflow_hidden");

  jQuery('#information_correct').rules("add", {
    required: true
  });
}

function hideLayer() {
  layerOpen = false;
  jQuery('.tournament_check').removeClass("show");
  jQuery('body').removeClass("overflow_hidden");
  jQuery('#information_correct').rules("remove");
}

function updateLayer() {
  jQuery('.firstname_text').text(jQuery('#firstname').val());
  jQuery('.lastname_text').text(jQuery('#lastname').val());
  jQuery('.street_text').text(jQuery('#street').val() + ' ' + jQuery('#street_number').val());
  jQuery('.city_text').text(jQuery('#postcode').val() + ' ' + jQuery('#city').val());
  jQuery('.email_text').text(jQuery('#email').val());
  jQuery('.birth_text').text(jQuery('#birth').val());
  jQuery('.phone_text').text(jQuery('#phone').val());
  jQuery('.country_text').text(jQuery('#country').val());

  jQuery('.firstname_participant_1_text').text(jQuery('#firstname_participant_1').val());
  jQuery('.lastname_participant_1_text').text(jQuery('#lastname_participant_1').val());
  jQuery('.street_participant_1_text').text(jQuery('#street_participant_1').val() + ' ' + jQuery('#street_number_participant_1').val());
  jQuery('.city_participant_1_text').text(jQuery('#postcode_participant_1').val() + ' ' + jQuery('#city_participant_1').val());
  jQuery('.birth_participant_1_text').text(jQuery('#birth_participant_1').val());
  jQuery('.gender_participant_1_text').text(jQuery('#gender_participant_1').val());
  jQuery('.size_participant_1_text').text(jQuery('#size_participant_1').val());

  jQuery('.firstname_participant_2_text').text(jQuery('#firstname_participant_2').val());
  jQuery('.lastname_participant_2_text').text(jQuery('#lastname_participant_2').val());
  jQuery('.street_participant_2_text').text(jQuery('#street_participant_2').val() + ' ' + jQuery('#street_number_participant_2').val());
  jQuery('.city_participant_2_text').text(jQuery('#postcode_participant_2').val() + ' ' + jQuery('#city_participant_2').val());
  jQuery('.birth_participant_2_text').text(jQuery('#birth_participant_2').val());
  jQuery('.gender_participant_2_text').text(jQuery('#gender_participant_2').val());
  jQuery('.size_participant_2_text').text(jQuery('#size_participant_2').val());

}

function validateParticipant2() {

  if (jQuery(participant2List[0]).val() != '' || jQuery(participant2List[1]).val() != '') {
    jQuery.each(participant2List, function () {
      jQuery(this).attr("placeholder", jQuery(this).data('placeholder') + " *");
      jQuery(this).rules("add", {
        required: true
      });
    })
  } else {
    jQuery.each(participant2List, function () {
      jQuery(this).attr("placeholder", jQuery(this).data('placeholder'));
      jQuery(this).rules("remove");
    })
  }

  //$("#registration").valid();
}

function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

class Tournament {
  init() {
    this.initPage();
    this.initParallax();
    this.initForm();
  }

  initPage = () => {
    $('.header_stoerer').addClass('hide');

    jQuery('.tournament_back_button').click(function (e) {
      e.preventDefault();
      hideLayer();
    });

    jQuery.each(participant2List, function (index, value) {

      jQuery(value).change(function () {

        // if firstname or lastname of teilnehmer is selected
        if (jQuery(participant2List[0]).val() != '' || jQuery(participant2List[1]).val() != '') {
          jQuery.each(participant2List, function () {
            jQuery(this).attr("placeholder", jQuery(this).data('placeholder') + " *");
            jQuery(this).rules("add", {
              required: true
            });
          })
        } else {
          jQuery.each(participant2List, function () {
            jQuery(this).attr("placeholder", jQuery(this).data('placeholder'));
            jQuery(this).rules("remove");
          })
        }

        $("#registration").valid();
      })
    });
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header');
  }

  initForm = () => {
    this.resetForm();
    //this.resetForm_dummy();
    this.updateForm();
    const formMessages = jQuery('#form-messages');

    jQuery("#registration").validate({
      rules: {
        firstname: 'required',
        lastname: 'required',
        email: {
          required: true,
          email: true
        },
        email_repeat: {
          required: true,
          email: true,
          equalTo: '#email'
        },
        street: 'required',
        street_number: 'required',
        postcode: 'required',
        city: 'required',
        birth: 'required',
        phone: 'required',
        country: {
          required: true
        },
        firstname_participant_1: 'required',
        lastname_participant_1: 'required',
        street_participant_1: 'required',
        street_number_participant_1: 'required',
        postcode_participant_1: 'required',
        city_participant_1: 'required',
        birth_participant_1: 'required',
        gender_participant_1: 'required',
        size_participant_1: {
          required: true
        },
        participation: 'required',
        nomination: 'required'
      },
      messages: {
        firstname: 'Bitte gebe Deinen Vornamen ein.',
        lastname: 'Bitte gebe Deinen Nachnamen ein.',
        email: 'Bitte gebe Deine korrekte E-Mail ein.',
        email_repeat: 'Bitte gebe Deine korrekte E-Mail erneut ein.',
        street: 'Bitte gebe Deine Strasse ein.',
        street_number: 'Bitte gebe Deine Hausnummer ein.',
        postcode: 'Bitte gebe Deine Postleitzahl ein.',
        city: 'Bitte gebe Deinen Ort ein.',
        phone: 'Bitte gebe Deine Telefonnummer ein.',
        country: 'Bitte gebe Dein Land ein.',
        birth: 'Bitte geben Sie Ihr Geburtsdatum ein.',
        firstname_participant_1: 'Bitte gebe den Vornamen des 1. Teilnehmers ein.',
        lastname_participant_1: 'Bitte gebe den Nachnamen des 1. Teilnehmers ein.',
        street_participant_1: 'Bitte gebe die Strasse des 1. Teilnehmers ein.',
        street_number_participant_1: 'Bitte gebe die Hausnummer des 1. Teilnehmers ein.',
        postcode_participant_1: 'Bitte gebe die Postleitzahl des 1. Teilnehmers ein.',
        city_participant_1: 'Bitte gebe den Ort des 1. Teilnehmers ein.',
        birth_participant_1: 'Bitte gebe das Geburtsdatum des 1. Teilnehmers ein.',
        gender_participant_1: 'Bitte gebe das Geschlecht des 1. Teilnehmers ein.',
        size_participant_1: 'Bitte gebe die Kleidergröße des 1. Teilnehmers ein.',
        firstname_participant_2: 'Bitte gebe den Vornamen des 2. Teilnehmers ein.',
        lastname_participant_2: 'Bitte gebe den Nachnamen des 2. Teilnehmers ein.',
        street_participant_2: 'Bitte gebe die Strasse des 2. Teilnehmers ein.',
        street_number_participant_2: 'Bitte gebe die Hausnummer des 2. Teilnehmers ein.',
        postcode_participant_2: 'Bitte gebe die Postleitzahl des 2. Teilnehmers ein.',
        city_participant_2: 'Bitte gebe den Ort des 2. Teilnehmers ein.',
        birth_participant_2: 'Bitte gebe das Geburtsdatum des 2. Teilnehmers ein.',
        gender_participant_2: 'Bitte gebe das Geschlecht des 2 Teilnehmers ein.',
        size_participant_2: 'Bitte gebe die Kleidergröße des 2. Teilnehmers ein.',

        participation: 'Bitte akzeptiere die Teilnahmebedingungen und Datenschutzbestimmungen.',
        analysis: 'Bitte akzeptiere die Bedingungen.',
        nomination: 'Hast Du die Nominierten in Kenntnis gesetzt?',
        information_correct: 'Bitte akzeptiere die Bedingungen.'
      },
      submitHandler(form) {

        if (layerOpen === false) {
          showLayer();
        } else {
          const formData = jQuery(form).serializeArray().reduce((obj, item) => {
            obj[item.name] = item.value;
            return obj;
          }, {});
          jQuery('.button_form_send').addClass('button_loading');
          jQuery.ajax({
            type: 'POST',
            url: 'https://nl7bwuw43d2h6bdccpcxlmt4l40digct.lambda-url.eu-central-1.on.aws/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            dataType: 'json',
            processData: false,
          })
            .done(function (response) {
              if(response){ // check whether response is received
                window.location.href = "tournament_thankyou.html";
              }
              formMessages.text(response.message);
            })
            .fail(function (data) {
              formMessages.text(data.message || 'Oops! An error occurred and your message could not be sent.');
            });

          //form.submit();
        }
      }
    });

    // check url params

    validateParticipant2();
  }

  resetForm_dummy() {
    jQuery('#firstname').val('Max');
    jQuery('#lastname').val('Mustermann');
    jQuery('#email').val('test@mail.de');
    jQuery('#email_repeat').val('test@mail.de');
    jQuery('#street').val('Musterstrasse ');
    jQuery('#street_number').val('12');
    jQuery('#postcode').val('22222');
    jQuery('#city').val('Musterstadt');
    jQuery('#birth').val('2017-02-26');
    jQuery('#phone').val('1234 567890');
    jQuery('#country').val('deutschland');

    jQuery('#firstname_participant_1').val('Peter');
    jQuery('#lastname_participant_1').val('Pertersen');
    jQuery('#street_participant_1').val('Peterstrasse ');
    jQuery('#street_number_participant_1').val('12');
    jQuery('#postcode_participant_1').val('12345');
    jQuery('#city_participant_1').val('Petersburg');
    jQuery('#birth_participant_1').val('2014-02-26');
    jQuery('#gender_participant_1').val('männlich');
    jQuery('#size_participant_1').val('140');

    jQuery('#firstname_participant_2').val('');
    jQuery('#lastname_participant_2').val('');
    jQuery('#street_participant_2').val('');
    jQuery('#street_number_participant_2').val('');
    jQuery('#postcode_participant_2').val('');
    jQuery('#city_participant_2').val('');
    jQuery('#birth_participant_2').val('');
    jQuery('#gender_participant_2').val('');
    jQuery('#size_participant_2').val('');

    jQuery('#participation').prop('checked', true);
    jQuery('#analysis').prop('checked', true);
    jQuery('#nomination').prop('checked', true);
    jQuery('#information_correct').prop('checked', false);
  }

  resetForm = () => {
    jQuery('#firstname').val('');
    jQuery('#lastname').val('');
    jQuery('#email').val('');
    jQuery('#email_repeat').val('');
    jQuery('#street').val('');
    jQuery('#street_number').val('');
    jQuery('#postcode').val('');
    jQuery('#city').val('');
    jQuery('#birth').val('');
    jQuery('#phone').val('');
    jQuery('#country').val('');

    jQuery('#firstname_participant_1').val('');
    jQuery('#lastname_participant_1').val('');
    jQuery('#street_participant_1').val('');
    jQuery('#street_number_participant_1').val('');
    jQuery('#postcode_participant_1').val('');
    jQuery('#city_participant_1').val('');
    jQuery('#birth_participant_1').val('');
    jQuery('#gender_participant_1').val('');
    jQuery('#size_participant_1').val('');

    jQuery('#firstname_participant_2').val('');
    jQuery('#lastname_participant_2').val('');
    jQuery('#street_participant_2').val('');
    jQuery('#street_number_participant_2').val('');
    jQuery('#postcode_participant_2').val('');
    jQuery('#city_participant_2').val('');
    jQuery('#birth_participant_2').val('');
    jQuery('#gender_participant_2').val('');
    jQuery('#size_participant_2').val('');

    jQuery('#participation').prop('checked', false);
    jQuery('#analysis').prop('checked', false);
    jQuery('#nomination').prop('checked', false);
    jQuery('#information_correct').prop('checked', false);
  }

  updateForm = () => {
    const recordId = getUrlParameter('recordId');
    fetch(`https://oblptjwnbxx76mmt3xba6vt62y0uouwh.lambda-url.eu-central-1.on.aws/${recordId}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        jQuery('#recordId').val(data.id);
        jQuery('#firstname').val(data.fields.Firstname);
        jQuery('#lastname').val(data.fields.Lastname);
        jQuery('#email').val(data.fields.Email);
        jQuery('#email_repeat').val(data.fields.Email);
        jQuery('#street').val(data.fields.Street);
        jQuery('#street_number').val(data.fields["Street Number"]);
        jQuery('#postcode').val(data.fields.Postcode);
        jQuery('#city').val(data.fields.City);
        // #jQuery('#phone').val();
        jQuery('#country').val(data.fields.Country);
        jQuery('#firstname_participant_1').val(data.fields["Firstname Participant 1"]);
        jQuery('#lastname_participant_1').val(data.fields["Lastname Participant 1"]);
        jQuery('#birth_participant_1').val(data.fields["Birth Participant 1"]);
        //jQuery('#gender_participant_1').val();
        //jQuery('#size_participant_1').val();
        jQuery('#firstname_participant_2').val(data.fields["Firstname Participant 2"]);
        jQuery('#lastname_participant_2').val(data.fields["Lastname Participant 2"]);
        jQuery('#birth_participant_2').val(data.fields["Birth Participant 2"]);
        //jQuery('#gender_participant_2').val();
        //jQuery('#size_participant_2').val(getUrlParameter('size_participant_2'));

        jQuery('#participation').prop('checked', false);
        jQuery('#analysis').prop('checked', false);
        jQuery('#nomination').prop('checked', false);

      });
  }
}

export default Tournament;
